import { getSessionUukey } from 'helpers/cookies';

const BASE_URL = 'http://localhost:3000';

async function fetchWithAuth(url, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    'Session-Uukey': getSessionUukey(),
    ...(options.headers || {})
  };
  const opts = { ...options, headers };
  const res = await fetch(url, opts);
  if (!res.ok) throw new Error(await res.text());
  if (res.status === 204) return {};
  return res.json();
}

export const shiftTemplateService = {
  getTemplates: (locationId, params = {}) => {
    const url = new URL(BASE_URL + '/api/customer/user_role/shift_templates');
    url.search = new URLSearchParams({ location_id: locationId, ...params }).toString();
    return fetchWithAuth(url.toString(), { method: 'GET' });
  },
  getTemplate: (templateId) => {
    return fetchWithAuth(`${BASE_URL}/api/customer/user_role/shift_templates/${templateId}`, { method: 'GET' });
  },
  createTemplate: (templateData) => {
    return fetchWithAuth(`${BASE_URL}/api/customer/user_role/shift_templates`, {
      method: 'POST',
      body: JSON.stringify({ shift_template: templateData })
    });
  },
  updateTemplate: (templateId, templateData) => {
    return fetchWithAuth(`${BASE_URL}/api/customer/user_role/shift_templates/${templateId}`, {
      method: 'PUT',
      body: JSON.stringify({ shift_template: templateData })
    });
  },
  deleteTemplate: (templateId) => {
    return fetchWithAuth(`${BASE_URL}/api/customer/user_role/shift_templates/${templateId}`, {
      method: 'DELETE' });
  },
  applyTemplate: (templateId, startDate, endDate) => {
    return fetchWithAuth(`${BASE_URL}/api/customer/user_role/shift_templates/${templateId}/apply`, {
      method: 'POST',
      body: JSON.stringify({ start_date: startDate, end_date: endDate })
    });
  }
}; 